import axiosInstance from "../../api/axiosConfig";
import { handleAPIError } from "../../api/utils/errors";
import type { FormCommentThread, NewFormComment } from "./commentsModel";

const commentsUrl = (individualId: string, filledFormId: string) =>
  `/individuals/${individualId}/case_extend_uscis_forms/${filledFormId}/comments`;

const rethrow = (error: unknown): never => {
  const apiError = handleAPIError(error);
  throw apiError;
};

export const FormCommentsAPI = {
  async list(
    individualId: string,
    filledFormId: string
  ): Promise<FormCommentThread[]> {
    try {
      const response = await axiosInstance.get<{
        comments: FormCommentThread[];
      }>(commentsUrl(individualId, filledFormId));
      return Array.isArray(response.data?.comments)
        ? response.data.comments
        : [];
    } catch (error) {
      return rethrow(error);
    }
  },

  async create(
    individualId: string,
    filledFormId: string,
    payload: NewFormComment
  ): Promise<FormCommentThread> {
    try {
      const response = await axiosInstance.post<{
        comment: FormCommentThread;
      }>(commentsUrl(individualId, filledFormId), payload);
      return response.data.comment;
    } catch (error) {
      return rethrow(error);
    }
  },

  async reply(
    individualId: string,
    filledFormId: string,
    commentId: string,
    body: string
  ): Promise<FormCommentThread> {
    try {
      const response = await axiosInstance.post<{
        comment: FormCommentThread;
      }>(`${commentsUrl(individualId, filledFormId)}/${commentId}/replies`, {
        body
      });
      return response.data.comment;
    } catch (error) {
      return rethrow(error);
    }
  },

  async update(
    individualId: string,
    filledFormId: string,
    commentId: string,
    patch: { resolved?: boolean; body?: string }
  ): Promise<FormCommentThread> {
    try {
      const response = await axiosInstance.patch<{
        comment: FormCommentThread;
      }>(`${commentsUrl(individualId, filledFormId)}/${commentId}`, patch);
      return response.data.comment;
    } catch (error) {
      return rethrow(error);
    }
  }
};
